import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from '@mui/material';
import CustomText, { textStyles } from "../../../components/CustomText";
import BaseCard from '../../../components/Cards/Card';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery';
import { toast, Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import verify from "../../../assets/verify.svg";
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { BASE_URL } from '../../../components/BaseUrl';
import { setOtpData, setResetToken } from '../../../Redux/Slices/AuthSlice';
import { useLocation } from 'react-router-dom';
import { apiFetch } from '../../../utils/apiService';
const VerificationScreen = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation(); // 👈 get state from navigation

  const [otpInput, setOtpInput] = useState(["", "", "", "", "", ""]);
  const [isVerifying, setIsVerifying] = useState(false);
  const [isResending, setIsResending] = useState(false);

  const inputRefs = useRef([]);

  const { otpData } = useSelector((state) => state.auth);
  const email = otpData?.email;
  const otp = otpData?.otp;

  // useEffect(() => {
  //   if (otp?.length === 6) {
  //     setOtpInput(otp.split(""));
  //   }
  // }, [otp]);

  const [seconds, setSeconds] = useState(15); // start with 15 when component mounts

useEffect(() => {
  if (seconds > 0) {
    const timer = setTimeout(() => setSeconds(prev => prev - 1), 1000);
    return () => clearTimeout(timer);
  }
}, [seconds]);

const handleResend = async () => {
  if (!email) return toast.error(t("otp.missingEmail"));

  setIsResending(true);
  try {
    const data = await apiFetch(`${BASE_URL}/company-admins/forgot-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    if (!data.ok || data.error) throw new Error(data.message || t("otp.resendFailed"));

    dispatch(setOtpData({ email, otp: data.data.debugCode }));
    toast.success(data.message || t("otp.resendSuccess"));

    setSeconds(15); // reset timer after resend
  } catch (err) {
    toast.error(err.message);
  } finally {
    setIsResending(false);
  }
};

  const handleChange = (index, value) => {
    const newOtp = [...otpInput];
    newOtp[index] = value.slice(-1);
    setOtpInput(newOtp);
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otpInput[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
const handlePaste = (e) => {
  e.preventDefault();
  const pasteData = e.clipboardData.getData("text").trim();

  // ✅ Accept only 1–6 digits
  if (!/^\d{1,6}$/.test(pasteData)) return;

  // ✅ Split into array and fill state
  const newOtp = pasteData.split("").slice(0, 6);
  setOtpInput(newOtp);

  // ✅ Focus last filled box
  const lastIndex = newOtp.length - 1;
  if (lastIndex >= 0) inputRefs.current[lastIndex]?.focus();
};


  const handleVerify = async () => {
    const finalOtp = otpInput.join("");
    console.log(email,finalOtp)
    if (finalOtp.length !== 6) {
      toast.error(t("otp.invalidCode"));
      return;
    }

    setIsVerifying(true);

    try {
      const data = await apiFetch(`${BASE_URL}/company-admins/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, verificationCode: finalOtp }),
      });
console.log(data)
      if (!data.ok || data.error) {
        const message = data.message || t("otp.verificationFailed");
        toast.error(message);
        return;
      }

      toast.success(data.message || t("otp.verifiedSuccess"));
      dispatch(setResetToken(data.data.resetToken));
      setSeconds(15); // Start resend timer after verify

      setTimeout(() => {
        navigate("/reset-password", {
          state: {
            email,
            otp: finalOtp,
            resetToken: data.data.resetToken,
          },
        });
      }, 1000);
    } catch (err) {
          console.error("Verify OTP API error:", err); // ✅ catch network/parse errors

      toast.error(t("otp.verificationFailed"));
    } finally {
      setIsVerifying(false);
    }
  };



  return (
    <Box sx={{ backgroundColor: "#EFF4F8", }}>

      <Box sx={{ py: isMobile ? 5 : 10, px: 2, display: 'flex', justifyContent: 'center' }}>
        <BaseCard
          maxWidth={isMobile ? '100%' : 400}
          sx={{
            width: isMobile ? '100%' : 'auto',
            px: isMobile ? 2 : 0,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
            <img src={verify} alt="Verify Icon" />
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <CustomText sx={{ ...textStyles.h4, color: theme.palette.tertiary.main }}>
              {t('verification.title')}
            </CustomText>

            <CustomText sx={{
              ...textStyles.body4,
              color: theme.palette.text.primary,
              lineHeight: 1.3,
              whiteSpace: 'pre-line'
            }}>
              {t('verification.subtitle')}
            </CustomText>

            {/* OTP Input */}
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
              {otpInput.map((digit, index) => (
                <TextField
                  key={index}
                  value={digit}
                  inputRef={el => inputRefs.current[index] = el}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                     onPaste={handlePaste} 
                  inputProps={{
                    maxLength: 1,
                    style: {
                      textAlign: 'center',
                      fontSize: '24px',
                      width: '45px',
                      height: '30px',
                    },
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '12px',
                      '& fieldset': {
                        borderColor: digit ? theme.palette.primary.main : '#ccc',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: theme.palette.primary.main,
                        borderWidth: '2px',
                      },
                    },
                  }}
                />
              ))}
            </Box>

            {/* Verify Button */}


            {/* Resend Section */}
            <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
              <CustomText sx={{ ...textStyles.body4, color: theme.palette.text.primary, textAlign: 'center' }}>
                {t("otp.resendText")}{" "}
                {seconds > 0 ? (
                  <Typography

                    sx={{
                      color: theme.palette.primary.main, fontWeight: 500, fontSize: "15px",
                      fontFamily: 'Poppins, sans-serif',
                    }}
                  >
                   {seconds}s

                    {/* {timer > 0 ? `${timer}s` : t("otp.resendButton")} */}
                  </Typography>
                ) : (
                  <Typography
                    component="span"
                    onClick={handleResend}
                    sx={{
                      color: theme.palette.primary.main,
                      fontWeight: 400,
                      cursor: isResending ? 'not-allowed' : 'pointer',
                      opacity: isResending ? 0.5 : 1,
                      textDecoration: 'underline',
                      fontSize: "15px",
                      fontFamily: 'Poppins, sans-serif',
                    }}
                  >
                    {t("otp.resendButton")}
                  </Typography>
                )}
              </CustomText>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button

                onClick={handleVerify}

                sx={{
                  backgroundColor: theme.palette.primary.main,
                  color: '#fff',
                  borderRadius: "6px",
                  px: 4,
                  height: 43,
                  textTransform: "none",
                  fontWeight: 300,
                  fontSize: 16,
                  fontFamily: 'Poppins, sans-serif',
                  '&:hover': {
                    backgroundColor: theme.palette.primary.dark,
                  },
                }}
              >
                {isVerifying ? (
                  <>
                    <CircularProgress size={20} thickness={4} sx={{ color: 'white' }} />
                    <span style={{ marginLeft: 8 }}>
                      {t('verification.verifyButton') || "Verifying"}
                    </span>

                  </>
                ) : (
                  t('verification.verifyButton') || "Verify Code"
                )}
              </Button>
            </Box>
          </Box>
        </BaseCard>
      </Box>
    </Box>
  );
};

export default VerificationScreen;













